var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      (_vm.mapConfig.type === 1
      ? true
      : false)
        ? _c("echartMap", {
            attrs: {
              maps: _vm.echartConfig,
              changeData: _vm.changeData,
              isStatus: _vm.mapConfig.type === 1 ? true : false
            }
          })
        : _vm._e(),
      _vm._v(" "),
      (_vm.mapConfig.type === 2
      ? true
      : false)
        ? _c("goldenMap", {
            attrs: {
              searchData: _vm.changeData,
              isStatus: _vm.mapConfig.type === 2 ? true : false
            },
            on: { handleZoom: _vm.handleZoom, handleSync: _vm.handleSync }
          })
        : _vm._e(),
      _vm._v(" "),
      (_vm.mapConfig.type === 3
      ? true
      : false)
        ? _c("floorDistribution", {
            attrs: { isStatus: _vm.mapConfig.type === 3 ? true : false },
            on: { handleZoom: _vm.handleZoom }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64892dde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64892dde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/map/main_map.vue
// module id = null
// module chunks = 